'use client';

import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { playerGamificationRewardsOptions } from '@/queries/playerGamificationRewards/playerGamificationRewards.queries';
import { GamificationRewardType } from '@/queries/playerGamificationRewards/playerGamificationRewards.schema';

export const useUnclaimedGamificationRewardsCount = () => {
  const { data: groupedRewards } = useQuery(playerGamificationRewardsOptions.meGroupedRewards());

  return useMemo(() => {
    const rewardsCount = {
      totalRewards: 0,
      statusUpRewards: 0,
      levelUpRewards: 0,
    };

    groupedRewards?.forEach((rewardGroup) => {
      rewardsCount.totalRewards += rewardGroup.availableAmount;

      if (rewardGroup.type === GamificationRewardType.StatusUp) {
        rewardsCount.statusUpRewards += rewardGroup.availableAmount;
      }

      if (rewardGroup.type === GamificationRewardType.LevelUp) {
        rewardsCount.levelUpRewards += rewardGroup.availableAmount;
      }
    });

    return rewardsCount;
  }, [groupedRewards]);
};
